/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationProductFields } from './SimulationProductFields';
import {
    SimulationProductFieldsFromJSON,
    SimulationProductFieldsFromJSONTyped,
    SimulationProductFieldsToJSON,
    SimulationProductFieldsToJSONTyped,
} from './SimulationProductFields';
import type { SimulationKeyFigure } from './SimulationKeyFigure';
import {
    SimulationKeyFigureFromJSON,
    SimulationKeyFigureFromJSONTyped,
    SimulationKeyFigureToJSON,
    SimulationKeyFigureToJSONTyped,
} from './SimulationKeyFigure';

/**
 * 
 * @export
 * @interface SimulationFieldExtractionResult
 */
export interface SimulationFieldExtractionResult {
    /**
     * 
     * @type {boolean}
     * @memberof SimulationFieldExtractionResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimulationFieldExtractionResult
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {Array<SimulationProductFields>}
     * @memberof SimulationFieldExtractionResult
     */
    products?: Array<SimulationProductFields> | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationFieldExtractionResult
     */
    priceUnitId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationFieldExtractionResult
     */
    year?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SimulationFieldExtractionResult
     */
    validFrom?: Date | null;
    /**
     * 
     * @type {Array<SimulationKeyFigure>}
     * @memberof SimulationFieldExtractionResult
     */
    keyFigures?: Array<SimulationKeyFigure> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimulationFieldExtractionResult
     */
    missingHeaders?: Array<string> | null;
}

/**
 * Check if a given object implements the SimulationFieldExtractionResult interface.
 */
export function instanceOfSimulationFieldExtractionResult(value: object): value is SimulationFieldExtractionResult {
    return true;
}

export function SimulationFieldExtractionResultFromJSON(json: any): SimulationFieldExtractionResult {
    return SimulationFieldExtractionResultFromJSONTyped(json, false);
}

export function SimulationFieldExtractionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationFieldExtractionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(SimulationProductFieldsFromJSON)),
        'priceUnitId': json['priceUnitId'] == null ? undefined : json['priceUnitId'],
        'year': json['year'] == null ? undefined : json['year'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'keyFigures': json['keyFigures'] == null ? undefined : ((json['keyFigures'] as Array<any>).map(SimulationKeyFigureFromJSON)),
        'missingHeaders': json['missingHeaders'] == null ? undefined : json['missingHeaders'],
    };
}

export function SimulationFieldExtractionResultToJSON(json: any): SimulationFieldExtractionResult {
    return SimulationFieldExtractionResultToJSONTyped(json, false);
}

export function SimulationFieldExtractionResultToJSONTyped(value?: SimulationFieldExtractionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(SimulationProductFieldsToJSON)),
        'priceUnitId': value['priceUnitId'],
        'year': value['year'],
        'validFrom': value['validFrom'] == null ? undefined : (formatDateOnly(value['validFrom'] as any)),
        'keyFigures': value['keyFigures'] == null ? undefined : ((value['keyFigures'] as Array<any>).map(SimulationKeyFigureToJSON)),
        'missingHeaders': value['missingHeaders'],
    };
}

